import { LinkPreviewResponse } from '@src/api/shared/community/chatApiClient';
import SvgIconClose from '@src/assets/images/common/icon/close/SvgIconClose';
import { useState } from 'react';

type Props = {
  data: LinkPreviewResponse;
  isPinnedChat?: boolean;
  canHide?: boolean;
  onHide?: () => void;
};

const PreviewOgp = ({ data, isPinnedChat, canHide, onHide }: Props) => {
  const { url, siteName, title, description, image } = data;

  const favicon = `https://www.google.com/s2/favicons?sz=64&domain=${new URL(url).hostname}`;
  const [isHovered, setIsHovered] = useState(false);
  const [isButtonHovered, setIsButtonHovered] = useState(false);

  return (
    <div
      className='relative -ml-7 mt-2 pl-7'
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {canHide && onHide && isHovered && (
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onHide();
          }}
          onMouseEnter={() => setIsButtonHovered(true)}
          onMouseLeave={() => setIsButtonHovered(false)}
          className='absolute left-2 top-0 flex size-4 items-center justify-center transition'
        >
          <SvgIconClose color={isButtonHovered ? '#000000' : '#A0A0A0'} />
        </button>
      )}
      <a
        href={url}
        target='_blank'
        rel='noopener noreferrer'
        className={`block border-l-4 border-gray-200 pl-[12px] ${isPinnedChat ? '' : 'hover:bg-gray-10'}`}
      >
        <div className='flex items-center gap-2'>
          <img
            src={favicon}
            width={20}
            height={20}
            alt=''
            className='size-5 object-contain'
          />
          <p className='break-all text-xs font-medium'>{siteName}</p>
        </div>
        <h3 className='mt-2 break-all text-sm font-semibold leading-[1.83] text-link hover:underline'>
          {title || siteName}
        </h3>
        {description && (
          <p className='mt-[6px] line-clamp-2 break-all text-xs leading-[1.6]'>{description}</p>
        )}
        {image && (
          <div className='mt-4 w-full max-w-[360px] overflow-hidden rounded-[20px] border-2 border-gray-200'>
            <img
              src={image}
              alt=''
              className='w-full object-cover'
            />
          </div>
        )}
      </a>
    </div>
  );
};

export default PreviewOgp;
